import styles from './HeroSection.module.css';
import { LandingImage } from './LandingImage';
import { PrimaryCta } from './PrimaryCta';

type HeroSectionProps = {
	onCta: () => void;
	isInvited: boolean;
};

export const HeroSection = ({ onCta, isInvited }: HeroSectionProps) => (
	<section className={styles.section}>
		<div className={styles.canvas}>
			<div className={styles.frame}>
				<picture>
					<source srcSet="/landing/hero.avif" type="image/avif" />
					<source srcSet="/landing/hero.webp" type="image/webp" />
					<img
						src="/landing/hero.png"
						alt=""
						className={styles.bg}
						loading="eager"
						decoding="async"
						fetchPriority="high"
					/>
				</picture>
			</div>
			<div className={styles.shapeTop}>
				<LandingImage src="/landing/hero-shape-top.png" alt="" />
			</div>
			<div className={styles.shapeBottom}>
				<LandingImage src="/landing/hero-shape-bottom.png" alt="" />
			</div>
			<div className={styles.leftHeader}>
				<div className={styles.paper}>
					<div className={styles.paperInner}>
						<LandingImage
							src="/landing/hero-paper-left.png"
							alt=""
							className={styles.paperImg}
						/>
					</div>
				</div>
			</div>
			<div className={styles.header}>
				<span className={styles.eyebrow}>Your 24/7 marketing partner</span>
				<h1 className={styles.heading}>
					Wake up to a week&rsquo;s worth of marketing, already done.
				</h1>
				<p className={styles.sub}>
					An agentic marketing partner that thinks strategically, offers
					recommendations, and gives you back the hours your tools used to take.
				</p>
				<div className={styles.cta}>
					<PrimaryCta
						onClick={onCta}
						variant="light"
						label={isInvited ? 'Meet your teammate' : 'Join Waitlist'}
					/>
				</div>
			</div>
		</div>
	</section>
);
